import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  policyTypeDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Policy Type Name"
          className='mb-3'
          subtitle={policyTypeDetails?.name ? policyTypeDetails?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Policy Type Description"
          className='mb-3'
          subtitle={policyTypeDetails?.description ? policyTypeDetails?.description : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
